import React from 'react';

class Content extends React.Component {
    render() {
        return <div className="app-content">{this.props.children}</div>;
    }
}

class Header extends React.Component {
    render() {
        return <div className="app-content__header">{this.props.children}</div>;
    }
}

class Body extends React.Component {
    render() {
        return <div className="app-content__body">{this.props.children}</div>;
    }
}

export default Content;
export { Content, Header, Body };



// WEBPACK FOOTER //
// ./js/launch/components/AppContent.jsx